<h2 mat-dialog-title>Mark Order as Delivered</h2>

<div mat-dialog-content [formGroup]="form">
    <div class="d-flex align-items-center">
        <span>Order: <strong>{{ order.orderNr }}</strong> is delivered </span>
        <mat-checkbox class="ml-2" formControlName="isDelivered"></mat-checkbox>
    </div>
    <mat-form-field class="w-100" style="margin-top: 5px">
        <mat-label>Real Delivery Date</mat-label>
        <input matInput [matDatepicker]="dp" formControlName="realDeliveryDate" (click)="dp.open()">
        <mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
        @if (form.get('realDeliveryDate').hasError('required')) {
            <mat-error>Required Field</mat-error>
        }
    </mat-form-field>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">Cancel</button>
    <button mat-flat-button (click)="updateOrder()" [disabled]="!enableConfirmButton()" color="primary">Confirm</button>
</div>

<button mat-icon-button
        (click)="closeDialog()"
        style="position: absolute; top: 10px; right: 10px;"
        aria-label="Close dialog">
    <mat-icon>close</mat-icon>
</button>
